"use client"

import { useLanguage } from "../contexts/LanguageContext"
import { useTermsOfUse } from "../contexts/TermsOfUseContext"

const TermsOfUsePage = () => {
  const { language } = useLanguage()
  const { terms } = useTermsOfUse()
  const isRtl = language === "he"

  const pageStyle = {
    padding: "40px 0",
    marginTop: "100px",
  }

  return (
    <section
      className={`terms-page ${isRtl ? "rtl-text" : ""}`}
      style={{
        ...pageStyle,
        direction: isRtl ? "rtl" : "ltr",
        textAlign: isRtl ? "right" : "left",
      }}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="container">
        <div style={{ maxWidth: "900px", margin: "0 auto" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>{terms.title}</h1>
          {terms.updatedAt && (
            <p style={{ marginBottom: "2rem", color: "#777" }}>{terms.updatedAt}</p>
          )}

          {terms.sections.map((section) => (
            <div key={section.id} style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>{section.heading}</h2>
              {section.content.map((paragraph, index) => (
                <p key={index} style={{ marginBottom: "0.5rem", lineHeight: 1.7 }}>
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TermsOfUsePage
